import { Injectable, Injector } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { PrepaidServicesComponent } from './modals/prepaid-services/prepaid-services.component';
import { MatDialog, MatDialogRef, MatSnackBar } from "@angular/material";
import { SharedDataService } from './shared-data.service';
import { Router } from '@angular/router';
import { PageTitleService } from './core/page-title/page-title.service';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { get } from 'jquery';

@Injectable()
export class PrepaidServicesService {

  // public sharedDataService: SharedDataService | null = null;
  pageCLientName:string
  paywallUnpaidStatus:boolean
  public allowedClassroomsIds:any = [];
  public allowedClassroomNames:string = '';
  public excludedClassroomsIds:any=[]
  public excludedClassroomNames:string = '';
  selectedClassrooms = []
  constructor(
    private injector: Injector,
    public http:Http,
    public pageTitleService:PageTitleService,
    public router:Router,
    private dialog: MatDialog,
    public snackBar: MatSnackBar,
    private sharedDataService: SharedDataService,
    private prepaidDialog?: MatDialog,
  ) { }

  public async getSchoolAgreement() {
    if(!this.sharedDataService.school_id){
      return;
    }

    let aggreementurl = `/school_agreement?school_id=${this.sharedDataService.school_id}${this.sharedDataService.getActivityForUrl()}`;
    let res = await this.sharedDataService.httpGetAsync(aggreementurl);

    if (res.status == 200) {
      let result = Array.isArray(res.json()) ? [...res.json()] : []
      if (!result.length) {
        return
      }
      this.sharedDataService.school_agreement = JSON.stringify(result)
      this.initializePrepaidservices(this.pageCLientName)
      let showModal = false
      result = result.sort((a, b) => moment(a.Service_Package_Expiration_Date).diff(moment(b.Service_Package_Expiration_Date)));
      if(moment(result[0].Service_Package_Expiration_Date).isBefore(moment(), 'day')&& result[0].Service_Base_Package_Type=="Prepaid"){
        showModal = true
      }
      if(showModal){
        this.sharedDataService.showServicePackageAlert();
      }      
    }
    else{
      this.sharedDataService.handleErrorMessage(res);
    }
  }

  public async getSchoolPrepaidServices() {
    let tokenData = sessionStorage.getItem('tokenInfo');
    let userEmployeeId = tokenData ? JSON.parse(tokenData) : null
    if (!userEmployeeId) {
      return
    }

    let prepaidServicesUrl = `/micro_pricing/prepaid_service_transaction?school_id=${this.sharedDataService.school_id}&school_employee_id=${this.sharedDataService.school_emp_Id}&status=Completed,Pending&expiration=nonexpired${this.sharedDataService.getActivityForUrl()}`;    
    let res = await this.sharedDataService.httpGetAsync(prepaidServicesUrl);

    if (res.status == 200) {
      let result = Array.isArray(res.json()) ? [...res.json()] : []
      if (!result.length) {
        return
      }
      this.sharedDataService.school_prepaid_services = JSON.stringify(result)
      this.initializePrepaidservices(this.pageCLientName)

    }
    else{
      this.sharedDataService.handleErrorMessage(res);
    }
  }
  
  latestPrepaidSubscription:any;
  public  initializePrepaidservices(client_name){
    client_name?this.pageCLientName=client_name:''
    if(!this.pageCLientName){
      window.history.back()
      return
    }

    if (!this.latestPrepaidSubscription) {
      this.sharedDataService.showSpinner();
      this.getSchoolAgreement();
      this.getSchoolPrepaidServices();
      this.sharedDataService.closeSpinner();
      this.latestPrepaidSubscription = true;
    }

    this.allowedClassroomsIds = this.returnAllowedClassrooms();
    let allcacheclass = this.sharedDataService.schoolClassroomsCache ? [...JSON.parse(this.sharedDataService.schoolClassroomsCache)] : []
    let classroomArray = allcacheclass.map(item=>item.Classroom_Identifier);
    this.excludedClassroomsIds = _.xor(this.allowedClassroomsIds,classroomArray);

    let tempAllowedArrayNames = [];
    let tempExcludedArrayNames = [];
    for(let classroom of allcacheclass){
      if(this.allowedClassroomsIds.includes(classroom.Classroom_Identifier)){
        tempAllowedArrayNames.push(classroom.Classroom_Name);
      }else{
        tempExcludedArrayNames.push(classroom.Classroom_Name);
      }
    }

    this.allowedClassroomNames = tempAllowedArrayNames.join(', ');
    this.excludedClassroomNames = tempExcludedArrayNames.join(', ');

    let stat = this.sharedDataService.checkAgreementAndTransactions(this.pageCLientName)
    this.paywallUnpaidStatus = stat.hit_paywall || stat.hit_paywall==null
  }
   /**
    * 
   * @param class_id  An Array of all the Class ids only of the Ui the user is on.. if no classid is present dont parse any value for school wide
   * @param refreshAllowed A boolean variable to check if the user can refresh the screen or not
   * @param Client_Name the Client Application Resource name of the User 
   * @param callbackValue This Argument accepts a function that is called if the pay is successfull NB: Only when it is successfull
   */
  prePaidRef: MatDialogRef<PrepaidServicesComponent>;
  public verifySchoolPrepaid(class_id = [],Client_Name, refreshAllowed=false,callbackValue=()=>{}) {
    if(Client_Name){
      this.pageCLientName = Client_Name
    }
    // Sort Data for Classrooms and Employees and Students
    let returnClasses = []

    if (class_id.length) {
      returnClasses = class_id
    } else {
      returnClasses = [...JSON.parse(this.sharedDataService.schoolClassroomsCache || '[]').map(item => item.Classroom_Identifier)]
    }

    let schoolEmployees = [...JSON.parse(this.sharedDataService.schoolEmployeesCache)].sort((a, b) => {
      // Check if either item is the special item
      if (a.Full_Name2 === this.sharedDataService.user_full_name) return -1;
      if (b.Full_Name2 === this.sharedDataService.user_full_name) return 1;

      // If neither is the special item, sort alphabetically
      return a.Full_Name2.localeCompare(b.Full_Name2);
    });
    let SchoolStudents = []
    let serviceProvider = []

    if (this.sharedDataService.activeSchoolStudents) {
      SchoolStudents = [...JSON.parse(this.sharedDataService.activeSchoolStudents)]
    }
    if (this.sharedDataService.schoolServiceProvidersCache) {
      serviceProvider = [...JSON.parse(this.sharedDataService.schoolServiceProvidersCache)]
    }
    // End of Line

    const activePageClientID = this.sharedDataService.resolveClientResourceID(this.pageCLientName);
    if (!activePageClientID) {
      this.sharedDataService.celebrate('You are not authorized to access: ' + this.pageCLientName);
      return;
    }

    // Check if School should Hit Paywall
    let agreementTransaction:any = this.sharedDataService.checkAgreementAndTransactions(this.pageCLientName)
    if(agreementTransaction.hit_modal){
      this.sharedDataService.showAlert(
        "School Subscription Expired",
        "Your school subscription has expired. Click on 'Renew' to re-subscribe.",
        () => {
          this.router.navigate(["/school-subscriptions/subscriptions"])},()=>{
          this.prePaidRef = this.prepaidDialog.open(PrepaidServicesComponent, {
            width: "95vw",
            maxWidth:"95vw",
            height: "100vh",
            disableClose: true,
            panelClass: "PrepaidTransparent",
            data: {
              type: "paywall",
              feature:Client_Name,
              user_id: this.sharedDataService.user_id,
              user_name: this.sharedDataService.user_full_name,
              school_employees: schoolEmployees,
              classroom: returnClasses,
              school_students: SchoolStudents,
              url_base_path: this.sharedDataService.apiUrl,
              schoolServiceProvidersCache: serviceProvider,
              school_agreement_transaction: agreementTransaction,
              showAlert: (title,message,confirm_action,cancel_action,confirm_text,cancel_text) => this.sharedDataService.showAlert(title,message,confirm_action,cancel_action,confirm_text,cancel_text),
              refetchPrepaid: () => this.sharedDataService.getSchoolPrepaidServices(),
              celebrate: (message) => this.sharedDataService.celebrate(message),
              cancel_action: () => { this.prePaidRef.close(); this.prePaidRef = undefined },
              get_request: (url) => this.sharedDataService.getHttp(url),
              postHttp: (url, body) => this.sharedDataService.postHttp(url, body),
              paymentPost: (url, body) => this.sharedDataService.FreePostUrl(url, body),
              putHttp: (url, body) => this.sharedDataService.putHttp(url, body),
              confirm_action: () => { this.prePaidRef.close(); this.prePaidRef = undefined },
              intialiseClassrooms: () => { this.initializePrepaidservices(Client_Name) },
              callbackFunc:()=>{callbackValue()},
              refreshAllowed:refreshAllowed
            }
          })
        },
        'Renew',
        'Cancel'
      );
      
      return false;

    }
    else  if (agreementTransaction.hit_paywall) {
      this.prePaidRef = this.prepaidDialog.open(PrepaidServicesComponent, {
        width: "95vw",
        maxWidth:"95vw",
        height: "100vh",
        disableClose: true,
        panelClass: "PrepaidTransparent",
        data: {
          type: "paywall",
          feature:Client_Name,
          user_id: this.sharedDataService.user_id,
          user_name: this.sharedDataService.user_full_name,
          school_employees: schoolEmployees,
          classroom: returnClasses,
          school_students: SchoolStudents,
          url_base_path: this.sharedDataService.apiUrl,
          schoolServiceProvidersCache: serviceProvider,
          school_agreement_transaction: agreementTransaction,
          showAlert: (title,message,confirm_action,cancel_action,confirm_text,cancel_text) => this.sharedDataService.showAlert(title,message,confirm_action,cancel_action,confirm_text,cancel_text),
          refetchPrepaid: () => this.sharedDataService.getSchoolPrepaidServices(),
          celebrate: (message) => this.sharedDataService.celebrate(message),
          cancel_action: () => { this.prePaidRef.close(); this.prePaidRef = undefined },
          get_request: (url) => this.sharedDataService.getHttp(url),
          postHttp: (url, body) => this.sharedDataService.postHttp(url, body),
          paymentPost: (url, body) => this.sharedDataService.FreePostUrl(url, body),
          putHttp: (url, body) => this.sharedDataService.putHttp(url, body),
          confirm_action: () => { this.prePaidRef.close(); this.prePaidRef = undefined },
          intialiseClassrooms: () => { this.initializePrepaidservices(Client_Name) },
          callbackFunc:()=>{callbackValue()},
          refreshAllowed:refreshAllowed

        }
      })
      return false
    }else if(agreementTransaction.hit_paywall==null){
      this.sharedDataService.showAlert("Payment Verification","Your payment for this feature has not been verified yet. Please visit 'Subscriptions' to view the transaction history",()=>{this.router.navigate(["/my-subscriptions/subscriptions"])},()=>{},"Visit Subscription","Close")
    return false
    }else{
      return true
    }
  }

  public returnAllowedClassrooms(){
    if(!this.pageCLientName){
      return
    }
    let foundClassrooms = []
    let allcacheclass = this.sharedDataService.schoolClassroomsCache ? [...JSON.parse(this.sharedDataService.schoolClassroomsCache)] : []
    let clientresouceid = this.sharedDataService.resolveClientResourceID(this.pageCLientName)
    let allAgreements: any = this.sharedDataService.checkForCurrentAgreement()
    let allPrepaidServices: any = this.sharedDataService.school_prepaid_services ? [...JSON.parse(this.sharedDataService.school_prepaid_services)] : []
    allPrepaidServices = allPrepaidServices.filter(prepaid=>prepaid.Transaction_Status.toLowerCase()=="completed")
    if(!allAgreements.length){
      return []
    }
    // Use agreement with the oldest expiration date
    let latestAgreement = allAgreements[0]
    if(!clientresouceid){
      this.sharedDataService.celebrate("No app id found")
      return
    }
    if(moment(latestAgreement.Service_Package_Expiration_Date).isBefore(moment(), 'day')){
      let preptransaction = allPrepaidServices.filter(services=>services.Client_Application_Resource_Identifier==clientresouceid && services.Transaction_Status=="Completed" && !moment(services.Service_Expiration_Date).isBefore(moment(), 'day'))
      preptransaction.forEach(classrooms => {
       let classArray = classrooms.Prepaid_Service_Transaction_Classrooms.map(item=>item.Classroom_Identifier)
       foundClassrooms.push(...classArray)
      });
      if(!preptransaction.length){
        if(foundClassrooms.length<=0){
          foundClassrooms = allcacheclass.map(item=>item.Classroom_Identifier)
        }
      }
    }else{
      let services = latestAgreement.Service_Package_Client_Application_Resources.find(services=>services.Client_Application_Resource_Identifier==clientresouceid)
      if(services){
        let allclassList = this.sharedDataService.schoolClassroomsCache ? [...JSON.parse(this.sharedDataService.schoolClassroomsCache)] : []
       let classArray = allclassList.map(item=>item.Classroom_Identifier)
        foundClassrooms.push(...classArray)
      }else{
        let preptransaction = allPrepaidServices.filter(services=>services.Client_Application_Resource_Identifier==clientresouceid && services.Transaction_Status=="Completed" && !moment(services.Service_Expiration_Date).isBefore(moment(), 'day'))
        preptransaction.forEach(classrooms => {
        let classArray = classrooms.Prepaid_Service_Transaction_Classrooms.map(item=>item.Classroom_Identifier)
        foundClassrooms.push(...classArray)
        });
        
        if(!preptransaction.length){
          if(foundClassrooms.length<=0){
            foundClassrooms = allcacheclass.map(item=>item.Classroom_Identifier)
          }
        }
      }
    }

    return foundClassrooms
  }
  

  showPromptMessage(classroom?){
    let showThePrompt = !classroom ? true : this.excludedClassroomsIds.includes(classroom.Classroom_Identifier)?true:false;
    let arrayOfClassIDs = undefined;
    if(classroom){
      arrayOfClassIDs = [classroom.Classroom_Identifier];
    }
    else{
      arrayOfClassIDs = this.excludedClassroomsIds;
    }

    if(showThePrompt){
      this.sharedDataService.showAlert(
        classroom && classroom.Classroom_Name ? classroom.Classroom_Name : "Not In Subscription",
        "Your current subscription does not grant you access to this classroom for this feature. Click continue to get access to this classroom for this feature.",
        () => {
          this.callPaywallOnly(arrayOfClassIDs);
        },
        () => {},
        'Continue',
        'Cancel'
      );
    }
  }

  public excludedClassroomsWarning(){
    if (this.excludedClassroomsIds.length) {
      this.sharedDataService.showAlert(
        'Excluded Classrooms',
        'Your current subscription does not grant you access to these classroom(s) for this feature and are excluded from the results: ' + this.excludedClassroomNames + '.', 
        () => {},
        () => {},
        'Okay'
      );
    }
  }


  callPaywallOnly(arrayOfClassrooms?){
    if(!this.pageCLientName){
      this.router.navigate(['/my-subscriptions/subscriptions'])
    }
    // Sort Data for Classrooms and Employees and Students
    let returnClasses = arrayOfClassrooms ? arrayOfClassrooms : [...JSON.parse(this.sharedDataService.schoolClassroomsCache || '[]').map(item => item.Classroom_Identifier)]

    let schoolEmployees = [...JSON.parse(this.sharedDataService.schoolEmployeesCache)].sort((a, b) => {
      // Check if either item is the special item
      if (a.Full_Name2 === this.sharedDataService.user_full_name) return -1;
      if (b.Full_Name2 === this.sharedDataService.user_full_name) return 1;

      // If neither is the special item, sort alphabetically
      return a.Full_Name2.localeCompare(b.Full_Name2);
    });
    let SchoolStudents = []
    let serviceProvider = []

    if (this.sharedDataService.activeSchoolStudents) {
      SchoolStudents = [...JSON.parse(this.sharedDataService.activeSchoolStudents)]
    }
    if (this.sharedDataService.schoolServiceProvidersCache) {
      serviceProvider = [...JSON.parse(this.sharedDataService.schoolServiceProvidersCache)]
    }

    let agreementTransaction:any = this.sharedDataService.checkAgreementAndTransactions(this.pageCLientName)

    this.prePaidRef = this.prepaidDialog.open(PrepaidServicesComponent, {
      width: "95vw",
      maxWidth:"95vw",
      height: "100vh",
      disableClose: true,
      panelClass: "PrepaidTransparent",
      data: {
        type: "paywall",
        feature:this.pageCLientName,
        user_id: this.sharedDataService.user_id,
        user_name: this.sharedDataService.user_full_name,
        school_employees: schoolEmployees,
        classroom: returnClasses,
        school_students: SchoolStudents,
        url_base_path: this.sharedDataService.apiUrl,
        schoolServiceProvidersCache: serviceProvider,
        school_agreement_transaction: agreementTransaction,
        showAlert: (title,message,confirm_action,cancel_action,confirm_text,cancel_text) => this.sharedDataService.showAlert(title,message,confirm_action,cancel_action,confirm_text,cancel_text),
        refetchPrepaid: () => this.sharedDataService.getSchoolPrepaidServices(),
        celebrate: (message) => this.sharedDataService.celebrate(message),
        cancel_action: () => { this.prePaidRef.close(); this.prePaidRef = undefined },
        get_request: (url) => this.sharedDataService.getHttp(url),
        postHttp: (url, body) => this.sharedDataService.postHttp(url, body),
        paymentPost: (url, body) => this.sharedDataService.FreePostUrl(url, body),
        putHttp: (url, body) => this.sharedDataService.putHttp(url, body),
        confirm_action: () => { this.prePaidRef.close(); this.prePaidRef = undefined },
        intialiseClassrooms: () => { this.initializePrepaidservices(this.pageCLientName) },
        refreshAllowed:true,

      }
    })
  }


}


// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/prepaid-services.service.ts